<template>
  <div class="closd-lang-selector">
    <v-select :model-value="$i18n.locale"
              item-title="code"
              item-value="code"
              color="blue-darken-2"
              :items="languages"
              variant="solo"
              density="comfortable"
              @update:model-value="localeChanged"
    >
      <template #selection="{ item }">
        <img :src="item.raw.urlSvg" class="flag" alt="selected language">
      </template>
      <template #item="{ item, props }">
        <v-list-item class="closd-lang-selector__menu-item" v-bind="props">
          <template #title>
            <img :src="item.raw.urlSvg" class="flag" alt="available language">
          </template>
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<script>
import { countryFlags } from '@/common/assets'

/**
 * Default lang selector
 * @displayName ClosdLangSelector
 */

/**
 * Display a select with lang choice
 */
export default {
  name: 'ClosdLangSelector',
  data () {
    return {
      languages: [
        { code: 'fr', urlSvg: countryFlags.fr },
        { code: 'en', urlSvg: countryFlags.en },
        { code: 'de', urlSvg: countryFlags.de },
        { code: 'es', urlSvg: countryFlags.es },
      ],
    }
  },
  methods: {
    /**
     * Gets called when the user change select value
     *
     * @param {String} newLocale The new lang selected
     */
    localeChanged (newLocale) {
      this.$i18n.locale = newLocale
      this.$router.replace({ ...this.$route, params: { locale: newLocale } })
    },
  },
}
</script>

<style lang="scss" scoped>
.closd-lang-selector {
  width: 75px;

  &__menu-item {
    display: flex;
    justify-content: center;
  }
  :deep(.v-field__append-inner) {
    padding-right: 4px !important;
  }
  :deep(.v-select) {
    display: flex;
  }
}

.flag{
  width: 25px;
  height: 19px;
}
</style>
